<mat-toolbar class="topBar">
    <div style="display:flex; align-items:center;">
  
      <!-- Back to Sets -->
      <button mat-icon-button
              class="example-icon"
              type="button"
              aria-label="Example icon-button with menu icon"
              [matTooltip]="matToolTipText"
              matTooltipPosition="below"
              (click)="navigateBack()">
        <mat-icon>
          arrow_back
        </mat-icon>
      </button>
  
      <!-- Back to Home -->
      <button mat-icon-button
              class="example-icon"
              type="button"
              matTooltip="Back to Home"
              matTooltipPosition="below"
              (click)="router.navigate(['menu'])">
        <mat-icon>
          home
        </mat-icon>
      </button>
  
      <span *ngIf="viewMode == 0">Current Delivery</span>
      <span *ngIf="viewMode == 1">Logbook</span>
      <span *ngIf="viewMode == 2">Editing Logbook</span>  
      <span *ngIf="viewMode == 3">Draft Logbook</span>
    </div>   
  
    <span class="spacer"></span>
  
    <mat-spinner *ngIf="dataSync.sync_in_progress()" [diameter]="35" class="mat-spinner-color"></mat-spinner>
    <!-- Enable edits -->
    <button mat-stroked-button
            *ngIf="viewMode != 0"
            class="edit-button"
            type="button"
            [hidden]="!canEdit"
            matTooltipPosition="below"
            (click)="viewMode == 1 ? enableEdits() : discardEdits(true)">
      <span *ngIf="viewMode == 1">
        Edit
      </span>
      <span *ngIf="viewMode == 2">
        Cancel
      </span>
    </button>
  
  </mat-toolbar>


  <div class="container" style="padding-top: 15px; max-width: none;;">

    <form [formGroup]="landingForm">

      <div class="row">
        <mat-form-field>
          <mat-label>Vessel</mat-label>
          <mat-select formControlName="vessel" [compareWith]="compareVessel" required>
            <mat-option *ngFor="let v of vesselOptions()" [value]="v">{{v}}</mat-option>
            <mat-option (click)="addVessel()">
              Add New
            </mat-option>
          </mat-select>
          <mat-error *ngIf="landingForm.invalid">Required</mat-error>
        </mat-form-field>
      </div>

      <div class="row">
        <mat-form-field>
          <mat-label>Vessel Operator</mat-label>
          <input matInput formControlName="operator" required>
          <mat-error *ngIf="landingForm.invalid">Required</mat-error>
        </mat-form-field>
      </div>

      <div class="row">
        <mat-form-field>
          <mat-label>Crew Size</mat-label>
          <input matInput type="text" inputmode="decimal" formControlName="crewSize" (input)="_forbidNonNumeric(landingForm.get('crewSize')!)" required>
          <mat-error *ngIf="landingForm.get('crewSize')?.errors?.required">Required</mat-error>
          <mat-error *ngIf="landingForm.get('crewSize')?.errors?.max">Must be 20 or less</mat-error>
          <mat-error *ngIf="landingForm.get('crewSize')?.errors?.min">Must be at least 1</mat-error>
        </mat-form-field>
      </div>

      <div class="row">
        <mat-form-field>
          <mat-label>
            Departure Date
          </mat-label>
          <input matInput readonly formControlName="departureDate" (click)="editDateTime('departureDate')" required>
          <mat-error *ngIf="landingForm.invalid">Required</mat-error>
        </mat-form-field>
      </div>
  
  
      <!-- This will be an auto-complete -->
      <div class="row">
        <mat-form-field>
          <mat-label>Departure Port</mat-label>
          <input matInput formControlName="departurePort" [matAutocomplete]="dept" required>
          <mat-autocomplete #dept="matAutocomplete">
            <mat-option *ngFor="let option of filteredDeparturePorts | async" [value]="option">
              {{option}}
            </mat-option>
          </mat-autocomplete>
          <mat-error *ngIf="landingForm.invalid">Select an item</mat-error>
        </mat-form-field>
      </div>
  
      <div class="row">
        <mat-form-field>
          <mat-label>
            Return Date
          </mat-label>
          <input matInput readonly formControlName="returnDate" (click)="editDateTime('returnDate')" required>
          <mat-error *ngIf="landingForm.invalid">Required</mat-error>
        </mat-form-field>
      </div>
  
  
      <!-- This will be an auto-complete -->
      <div class="row">
        <mat-form-field>
          <mat-label>Return Port</mat-label>
          <input matInput formControlName="returnPort" [matAutocomplete]="arrival" required>
          <mat-autocomplete #arrival="matAutocomplete">
            <mat-option *ngFor="let option of filteredArrivalPorts | async" [value]="option">
              {{option}}
            </mat-option>
          </mat-autocomplete>
          <mat-error *ngIf="landingForm.invalid">Select an item</mat-error>
        </mat-form-field>
      </div>

      <mat-divider></mat-divider>
      <div class="row align-items-center">
        <div class="col">
          <h3>Exempted Fishing Permit?</h3>
        </div>

        <div class="col">
          <div class="row" style="margin-bottom: 16px;">
            <mat-radio-group aria-label="Select an option" formControlName="isExemptedFP">
              <mat-radio-button [checked]="landingForm.get('isExemptedFP')?.value" [value]="true">Yes</mat-radio-button>
              <mat-radio-button [checked]="!landingForm.get('isExemptedFP')?.value" [value]="false" style="padding-left: 25px;">No</mat-radio-button>
            </mat-radio-group>
          </div>

        </div>

      </div>

      <mat-divider></mat-divider>
      <div class="row align-items-center">
        <div class="col">
          <h3>EM Trip?</h3>
        </div>

        <div class="col">
          <div class="row" style="margin-bottom: 16px;">
            <mat-radio-group aria-label="Select an option" formControlName="isEMTrip">
              <mat-radio-button [checked]="landingForm.get('isEMTrip')?.value" [value]="true">Yes</mat-radio-button>
              <mat-radio-button [checked]="!landingForm.get('isEMTrip')?.value" [value]="false" style="padding-left: 25px;">No</mat-radio-button>
            </mat-radio-group>
          </div>
        </div>

      </div>
      <mat-divider></mat-divider>

      <div class="row align-items-center">
        <div class="col">
          <h3>Observed Trip?</h3>
        </div>

        <div class="col">
          <div class="row" style="margin-bottom: 16px;">
            <mat-radio-group aria-label="Select an option" formControlName="isObservedTrip">
              <mat-radio-button [checked]="landingForm.get('isObservedTrip')?.value" [value]="true">Yes</mat-radio-button>
              <mat-radio-button [checked]="!landingForm.get('isObservedTrip')?.value" [value]="false" style="padding-left: 25px;">No</mat-radio-button>
            </mat-radio-group>
          </div>
        </div>

      </div>
      <mat-divider></mat-divider>
  
      <div class="row" style="margin-top: 16px;">
        <mat-form-field appearance="fill">
          <mat-label>Additional Comments</mat-label>
          <textarea matInput rows="4" formControlName="comments" [maxLength]="250"></textarea>
        </mat-form-field>
      </div>

    

      <div class="row">
        <div class="card-container" [style.opacity]="viewMode == 1 ? 0.5 : 1">
          <mat-card [ngClass]="!this.landingForm.get('atSeaDelivery')?.value ? 'card-selected' : 'card-normal'" (click)="onDeliveryMethodChange('shore')">
            <mat-card-content style="display: flex; justify-content: center;">Shoreside Delivery</mat-card-content>
          </mat-card>
          <mat-card [ngClass]="this.landingForm.get('atSeaDelivery')?.value ? 'card-selected' : 'card-normal'" (click)="onDeliveryMethodChange('sea')">
            <mat-card-content style="display: flex; justify-content: center;">At-Sea Delivery</mat-card-content>
          </mat-card>
        </div>
      </div>

      <div *ngIf="this.landingForm.get('atSeaDelivery')?.value" class="row">
        <mat-form-field>
          <mat-label>Mothership</mat-label>
          <mat-select formControlName="mothershipName" required>
            <mat-option *ngFor="let m of mothershipOptions()" [value]="m">{{m}}</mat-option>
            <mat-option (click)="addMothership()">
              Add New
            </mat-option>
          </mat-select>
          <mat-error *ngIf="landingForm.invalid">Required</mat-error>
        </mat-form-field>
      </div>

    </form>

    <div *ngIf="!this.landingForm.get('atSeaDelivery')?.value" class="row">
        <mat-toolbar style="background-color: #005d87; color: white; border-bottom: 3px solid coral;">
        <span>Fish Tickets</span>
        <span class="spacer"></span>

        <!-- Add Fish Ticket -->
        <button mat-mini-fab
                *ngIf="viewMode != 1"
                class="blue-icon-button"
                type="button"
                aria-label="Example icon-button with share icon"
                matTooltip="Add Fish Ticket"
                matTooltipPosition="below"
                (click)="openFishTicketDialog(landing.tickets.length)">
            <mat-icon>
            add
            </mat-icon>
        </button>
        </mat-toolbar>
    </div>

    <div *ngIf="!this.landingForm.get('atSeaDelivery')?.value" class="row">

        <table mat-table [dataSource]="landing.tickets" class="mat-elevation-z8">

            <!-- Buyer Column  -->
            <ng-container matColumnDef="Buyer">
                <tr>
                <th mat-header-cell *matHeaderCellDef> Buyer </th>
                <td mat-cell *matCellDef="let tck"> {{tck.buyer}} </td>
                </tr>
            </ng-container>

            <!-- Fish Ticket # Column -->
            <ng-container matColumnDef="Fish Ticket Number">
                <tr>
                <th mat-header-cell *matHeaderCellDef> Fish Ticket Number </th>
                <td mat-cell *matCellDef="let tck"> {{tck.ticketNumber}} </td>
                </tr>
            </ng-container>

            <!-- Date Column -->
            <ng-container matColumnDef="Date">
                <tr>
                <th mat-header-cell *matHeaderCellDef> Date </th>
                <td mat-cell *matCellDef="let tck"> {{tck.deliveryDate | date:'MMM-dd-yy'}} </td>
                </tr>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="fishTicketColumns"></tr>
            <tr mat-row (click)="openFishTicketDialog(index)" *matRowDef="let row; columns: fishTicketColumns; let index=index;"></tr>

        </table>

    </div>

    <div class="row">
        <mat-toolbar style="background-color: #005d87; color: white; border-bottom: 3px solid coral;">
          <span>Sets Included in Delivery</span>
          <span class="spacer"></span>

          <!-- Add Set to Delivery -->
          <button mat-mini-fab
                  *ngIf="viewMode != 1"
                  class="blue-icon-button"
                  type="button"
                  aria-label="Example icon-button with share icon"
                  matTooltip="Add Set to Delivery"
                  matTooltipPosition="below"
                  (click)="openSetSelection()">
            <mat-icon>
              add
            </mat-icon>
          </button>
        </mat-toolbar>
    </div>

    <div class="row">
      <div *ngFor="let set of sortedSets; let index=index;" style="padding-left: 0px; padding-right: 0px; font-size: 16px;">
          <mat-card matRipple (click)="goToSet(set.fishingEventID)" style="padding:16px;">
              <div class="row">
                  <div style="display: flex; flex-direction: column; align-items: flex-start;">
                      <span><b>Set: </b>{{set.startDate | date:'HH:mm, EE, MMM.dd'}}</span>
                      <span><b>Haul: </b>{{set.endDate | date:'HH:mm, EE, MMM.dd'}}</span>
                  </div>
                  <div style="display: flex; align-items: center; justify-content: flex-end;">
                      @let valid = validSets.get(set.fishingEventID);
                      <mat-icon *ngIf="viewMode == 1 || valid">done</mat-icon>
                      <mat-icon *ngIf="viewMode != 1 && !valid">error</mat-icon>
                  </div>
              </div>     
              <mat-card-actions *ngIf="(viewMode != 1 && !preExistingSets.get(set.fishingEventID)) && (viewMode != 3)">
                  <button mat-fab
                          class="text-button"
                          type="button"
                          (click)="removeSet(index)">
                      Remove
                  </button>
              </mat-card-actions>
              <mat-card-footer></mat-card-footer>
          </mat-card>   
          <br>               
      </div>    
  </div>
  
  

    <br>
    <br>
    <br>
    <br>
    <br>

  </div>
  

        
  <!-- Bottom bar -->
  <mat-toolbar class="toolbarNav" style="background-color: #004165;">
    <div class="example-button-container">

      <!-- Delivery Summary -->
      <button mat-fab
              class="bottom-toolbar-button"
              type="button"
              aria-label="Example icon button with a plus one icon"
              matTooltip="Summary"
              matTooltipPosition="above"
              (click)="router.navigate(['summary_report', 'Trawl', viewMode == 0 ? -1 : this.completedInd], { queryParams: { previous: previousScreen } })">
        <mat-icon>
          description
        </mat-icon>
      </button>
    </div>

    <!-- Delivery Errors -->
    <div *ngIf="errors.length > 0 && viewMode != 1" class="example-button-container">
      <button mat-fab
              class="bottom-toolbar-button"
              type="button"
              aria-label="Example icon button with a plus one icon"
              matTooltip="Errors/Warnings"
              matTooltipPosition="above"
              (click)="openErrorDialog()">
        <mat-icon *ngIf="onlyWarnings">
          warning
        </mat-icon>
        <mat-icon *ngIf="!onlyWarnings">
          report
        </mat-icon>
      </button>
    </div>

    <!-- Submit Delivery -->
    <div *ngIf="viewMode != 1" class="example-button-container">
      <button mat-fab
              class="bottom-toolbar-button"
              type="button"
              aria-label="Example icon button with a plus one icon"
              matTooltip="Submit Delivery"
              matTooltipPosition="above"
              (click)="openSubmitDialog()">
        <mat-icon>
          drive_folder_upload
        </mat-icon>
      </button>
    </div>

  </mat-toolbar>